<div class="gu-data-access">
  <mat-tab-group [(selectedIndex)]="selectedTabIndex">
    <mat-tab *ngIf="hasSecuredViewerAccess" label="Secured Viewer">
      <div class="tab-content">
        <div class="secured-viewer-container">
          <div class="viewer-header">
            <mat-icon>security</mat-icon>
            <span>Gesicherte Vorschau der dynamisch aufgelösten Berichte</span>
          </div>
          <div class="viewer-body">
            <div class="report-sections" *ngIf="reports.length">
              <div class="report-section" *ngFor="let report of reports" [class.is-expanded]="expandedReportId === report.reportId">
                <button type="button" class="report-section__header" (click)="toggleReport(report.reportId)">
                  <mat-icon class="report-section__icon">{{ expandedReportId === report.reportId ? 'expand_less' : 'expand_more' }}</mat-icon>
                  <span class="report-section__title">{{ report.label }}</span>
                  <span class="report-section__summary-title">{{ report.status }}</span>
                </button>
                <div class="report-section__body" *ngIf="expandedReportId === report.reportId">
                  <div class="report-section" *ngFor="let section of report.sections" [class.is-expanded]="isSectionExpanded(report.reportId, section.id)">
                    <button
                      type="button"
                      class="report-section__header"
                      (click)="toggleSection(report.reportId, section.id)">
                      <mat-icon class="report-section__icon">{{ isSectionExpanded(report.reportId, section.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
                      <span class="report-section__title">{{ section.title }}</span>
                      <span class="report-section__summary-title">{{ section.summaryTitle }}</span>
                    </button>
                    <div class="report-section__body" *ngIf="isSectionExpanded(report.reportId, section.id)">
                      <ng-container *ngIf="isArray(section.value); else objectOrPrimitive">
                        <table class="section-table" *ngIf="getArrayColumns(section.value) as cols">
                          <thead *ngIf="cols.length">
                            <tr>
                              <th *ngFor="let col of cols">{{ formatLabel(col) }}</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr *ngFor="let row of section.value">
                              <td *ngFor="let col of cols">
                                <ng-container *ngIf="isObject(row[col]); else cellPrimitive">
                                  <span class="inline-kv" *ngFor="let k of objectKeys(row[col])">
                                    <em>{{ formatLabel(k) }}:</em> {{ formatValue(row[col][k]) }}
                                  </span>
                                </ng-container>
                                <ng-template #cellPrimitive>{{ formatInlineValue(row[col]) }}</ng-template>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </ng-container>

                      <ng-template #objectOrPrimitive>
                        <ng-container *ngIf="isObject(section.value); else primitiveBlock">
                          <div class="section-kv-grid">
                            <ng-container *ngFor="let key of objectKeys(section.value)">
                              <ng-container *ngIf="isPrimitive(section.value[key])">
                                <div class="section-kv-item">
                                  <span class="section-kv-item__label">{{ formatLabel(key) }}</span>
                                  <span class="section-kv-item__value">{{ formatValue(section.value[key]) }}</span>
                                </div>
                              </ng-container>
                              <ng-container *ngIf="isObject(section.value[key]) && !isArray(section.value[key])">
                                <div class="section-kv--nested">
                                  <span class="section-kv-item__label">{{ formatLabel(key) }}</span>
                                  <div class="section-kv-grid section-kv-grid--sub">
                                    <div class="section-kv-item" *ngFor="let subKey of objectKeys(section.value[key])">
                                      <span class="section-kv-item__label">{{ formatLabel(subKey) }}</span>
                                      <span class="section-kv-item__value">{{ formatValue(section.value[key][subKey]) }}</span>
                                    </div>
                                  </div>
                                </div>
                              </ng-container>
                              <ng-container *ngIf="isArray(section.value[key])">
                                <div class="section-kv--nested">
                                  <span class="section-kv-item__label">{{ formatLabel(key) }} ({{ section.value[key].length }})</span>
                                  <table class="section-table section-table--mini" *ngIf="getArrayColumns(section.value[key]) as subCols">
                                    <thead *ngIf="subCols.length">
                                      <tr><th *ngFor="let col of subCols">{{ formatLabel(col) }}</th></tr>
                                    </thead>
                                    <tbody>
                                      <tr *ngFor="let row of section.value[key]">
                                        <td *ngFor="let col of subCols">{{ formatInlineValue(row[col]) }}</td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </ng-container>
                            </ng-container>
                          </div>
                        </ng-container>

                        <ng-template #primitiveBlock>
                          <div class="section-text-block">{{ formatValue(section.value) }}</div>
                        </ng-template>
                      </ng-template>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="search-results-placeholder" *ngIf="!reports.length">
              <mat-icon>visibility_off</mat-icon>
              <p>Keine Berichte im aktuellen Offer enthalten.</p>
            </div>
          </div>
        </div>

        <div class="viewer-dashboard" *ngIf="reports.length >= 1">
          <div class="viewer-dashboard__header">
            <mat-icon>insights</mat-icon>
            <h5>Aggregierte Auswertung</h5>
          </div>

          <div class="dashboard-chart-card dashboard-chart-card--combined" *ngIf="hasCombinedChartData; else emptyAggregations">
            <div class="dashboard-chart-card__heading">
              <div>
                <h5>Gemeinsamer Verlauf</h5>
                <p>Wetter links, Mengen und Stunden rechts.</p>
              </div>
            </div>

            <div class="combined-chart-toggle-list">
              <button
                type="button"
                class="combined-chart-toggle"
                *ngFor="let series of combinedChartSeries"
                [class.is-active]="series.visible"
                [class.is-inactive]="!series.visible"
                (click)="toggleChartSeries(series.key)">
                <span class="combined-chart-toggle__swatch" [style.background]="series.color"></span>
                <span class="combined-chart-toggle__label">{{ series.label }}</span>
                <span class="combined-chart-toggle__axis">{{ series.axis === 'left' ? 'links' : 'rechts' }}</span>
              </button>
            </div>

            <div class="combined-chart" *ngIf="visibleCombinedChartSeries.length; else noSeriesSelected">
              <svg class="combined-chart__svg" [attr.viewBox]="'0 0 ' + combinedChartWidth + ' ' + combinedChartHeight" preserveAspectRatio="xMidYMid meet">
                <g class="combined-chart__grid">
                  <line *ngFor="let gridLine of combinedChartGridLines"
                    [attr.x1]="combinedChartPadding.left"
                    [attr.x2]="combinedChartWidth - combinedChartPadding.right"
                    [attr.y1]="gridLine.y"
                    [attr.y2]="gridLine.y"></line>
                </g>

                <g class="combined-chart__axes">
                  <line [attr.x1]="combinedChartPadding.left" [attr.x2]="combinedChartPadding.left" [attr.y1]="combinedChartPadding.top" [attr.y2]="combinedChartBottom"></line>
                  <line [attr.x1]="combinedChartWidth - combinedChartPadding.right" [attr.x2]="combinedChartWidth - combinedChartPadding.right" [attr.y1]="combinedChartPadding.top" [attr.y2]="combinedChartBottom"></line>
                  <line [attr.x1]="combinedChartPadding.left" [attr.x2]="combinedChartWidth - combinedChartPadding.right" [attr.y1]="combinedChartBottom" [attr.y2]="combinedChartBottom"></line>
                </g>

                <g class="combined-chart__left-ticks">
                  <g *ngFor="let tick of combinedChartLeftTicks">
                    <text [attr.x]="combinedChartPadding.left - 12" [attr.y]="tick.y + 4">{{ tick.label }}</text>
                  </g>
                </g>

                <g class="combined-chart__right-ticks">
                  <g *ngFor="let tick of combinedChartRightTicks">
                    <text [attr.x]="combinedChartWidth - combinedChartPadding.right + 10" [attr.y]="tick.y + 4">{{ tick.label }}</text>
                  </g>
                </g>

                <g class="combined-chart__x-labels">
                  <g *ngFor="let tick of combinedChartXAxisLabels">
                    <text [attr.x]="tick.x" [attr.y]="combinedChartBottom + 22">{{ tick.label }}</text>
                  </g>
                </g>

                <g class="combined-chart__series" *ngFor="let series of visibleCombinedChartSeries">
                  <path *ngIf="series.path" class="combined-chart__line" [attr.d]="series.path" [attr.stroke]="series.color"></path>
                  <circle *ngFor="let point of series.points"
                    class="combined-chart__point"
                    [attr.cx]="point.x"
                    [attr.cy]="point.y"
                    [attr.r]="4"
                    [attr.fill]="series.color"
                    (mouseenter)="showChartPointTooltip(series, point)"
                    (mouseleave)="hideChartPointTooltip()">
                    <title>{{ series.label }} | {{ point.label }} | {{ point.value }}</title>
                  </circle>
                </g>

                <text class="combined-chart__axis-label combined-chart__axis-label--left"
                  [attr.x]="18"
                  [attr.y]="combinedChartPadding.top - 12">Temperatur °C</text>
                <text class="combined-chart__axis-label combined-chart__axis-label--right"
                  [attr.x]="combinedChartWidth - combinedChartPadding.right + 10"
                  [attr.y]="combinedChartPadding.top - 12">Anzahl / Stunden</text>
              </svg>

              <div class="combined-chart__tooltip"
                *ngIf="hoveredChartPoint"
                [style.left.px]="hoveredChartPoint.x"
                [style.top.px]="hoveredChartPoint.y - 14">
                <span class="combined-chart__tooltip-swatch" [style.background]="hoveredChartPoint.color"></span>
                <strong>{{ hoveredChartPoint.seriesLabel }}</strong>
                <span>{{ hoveredChartPoint.pointLabel }}</span>
                <span>Wert: {{ hoveredChartPoint.value }}</span>
              </div>
            </div>

            <ng-template #noSeriesSelected>
              <div class="viewer-dashboard__empty viewer-dashboard__empty--inline">
                <mat-icon>visibility_off</mat-icon>
                <span>Keine Serie ausgewählt. Aktiviere oben mindestens eine Kennzahl.</span>
              </div>
            </ng-template>
          </div>

          <ng-template #emptyAggregations>
            <div class="viewer-dashboard__empty">
              <mat-icon>bar_chart</mat-icon>
              <span>Keine aggregierbaren Daten in den Berichts-Payloads vorhanden (Wetter, Arbeitskräfte, Arbeitszeit, Ausgeführte Arbeiten).</span>
            </div>
          </ng-template>
        </div>
      </div>
    </mat-tab>

    <mat-tab *ngIf="hasComputeToDataAccess" label="Compute-to-Data">
      <div class="tab-content tab-content--compute">
        <div class="access-mode-banner access-mode-banner--compute">
          <mat-icon>memory</mat-icon>
          <div>
            <strong>Compute-to-Data Zugriff</strong>
            <span>Die Rohdaten bleiben beim Anbieter. Sie sehen nur das aggregierte Verarbeitungsergebnis.</span>
          </div>
        </div>

        <app-compute-to-data-panel></app-compute-to-data-panel>
      </div>
    </mat-tab>

    <mat-tab *ngIf="hasDeepSearchAccess" label="Deep Search (JSONB)">
      <div class="tab-content">
        <div class="search-mask">
          <mat-form-field appearance="outline" class="full-width">
            <mat-label>Deep Search (z.B. Leistungen, Bauteile)</mat-label>
            <input matInput
              [(ngModel)]="deepSearchTerm"
              (keyup.enter)="executeDeepSearch()"
              placeholder="Suchbegriff eingeben...">
            <button mat-icon-button matSuffix (click)="executeDeepSearch()">
              <mat-icon>travel_explore</mat-icon>
            </button>
          </mat-form-field>
          <div class="metadata-filters">
            <div class="metadata-filters__actions">
              <button type="button" class="filter-action-button" (click)="selectAllSearchSections()">Alle</button>
              <button type="button" class="filter-action-button" (click)="clearSearchSections()">Keine</button>
            </div>
            <div class="metadata-filters__chips">
              <button
                type="button"
                class="filter-chip"
                *ngFor="let sectionId of availableSearchSections"
                [class.is-active]="isSectionFilterActive(sectionId)"
                (click)="toggleSearchSection(sectionId)">
                {{ prettySection(sectionId) }}
              </button>
            </div>
            <span class="filter-hint" *ngIf="deepSearchSectionFilters.size === availableSearchSections.length && availableSearchSections.length">Alle Abschnitte ausgewählt</span>
            <span class="filter-hint" *ngIf="deepSearchSectionFilters.size > 0 && deepSearchSectionFilters.size < availableSearchSections.length">{{ deepSearchSectionFilters.size }} Abschnitte ausgewählt</span>
            <span class="filter-hint" *ngIf="availableSearchSections.length && deepSearchSectionFilters.size === 0">Keine Abschnitte ausgewählt</span>
          </div>
        </div>

        <div class="deep-search-examples" *ngIf="deepSearchExamples.length">
          <p class="examples-label">Beispielsuchen:</p>
          <button type="button" class="example-chip"
            *ngFor="let ex of deepSearchExamples"
            (click)="applyExample(ex.term)">
            <mat-icon>search</mat-icon> „{{ ex.term }}" — {{ ex.hint }}
          </button>
        </div>

        <ng-container *ngIf="deepSearchExecuted">
          <div class="deep-search-result-count" *ngIf="deepSearchResults.length">
            {{ deepSearchResults.length }} Treffer in {{ deepSearchReportCount }} Berichten
          </div>

          <div class="deep-search-results" *ngIf="deepSearchResults.length">
            <div class="deep-search-result" *ngFor="let result of deepSearchResults">
              <button type="button" class="deep-search-result__header"
                (click)="toggleDeepResult(result.reportId, result.sectionId)">
                <mat-icon class="deep-search-result__toggle">
                  {{ isDeepResultExpanded(result.reportId, result.sectionId) ? 'expand_less' : 'expand_more' }}
                </mat-icon>
                <span class="deep-search-result__report">{{ result.label }}</span>
                <span class="deep-search-result__section-badge">{{ result.sectionTitle }}</span>
                <span class="deep-search-result__context">{{ result.matchContext }}</span>
              </button>
              <div class="deep-search-result__body" *ngIf="isDeepResultExpanded(result.reportId, result.sectionId)">
                <ng-container *ngIf="isArray(result.payload); else deepObjectOrPrimitive">
                  <table class="section-table" *ngIf="getArrayColumns(result.payload) as cols">
                    <thead *ngIf="cols.length">
                      <tr><th *ngFor="let col of cols">{{ formatLabel(col) }}</th></tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let row of result.payload">
                        <td *ngFor="let col of cols">{{ formatInlineValue(row[col]) }}</td>
                      </tr>
                    </tbody>
                  </table>
                </ng-container>

                <ng-template #deepObjectOrPrimitive>
                  <ng-container *ngIf="isObject(result.payload); else deepPrimitiveBlock">
                    <div class="section-kv-grid">
                      <ng-container *ngFor="let key of objectKeys(result.payload)">
                        <ng-container *ngIf="isPrimitive(result.payload[key])">
                          <div class="section-kv-item">
                            <span class="section-kv-item__label">{{ formatLabel(key) }}</span>
                            <span class="section-kv-item__value">{{ formatValue(result.payload[key]) }}</span>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="isObject(result.payload[key]) && !isArray(result.payload[key])">
                          <div class="section-kv--nested">
                            <span class="section-kv-item__label">{{ formatLabel(key) }}</span>
                            <div class="section-kv-grid section-kv-grid--sub">
                              <div class="section-kv-item" *ngFor="let subKey of objectKeys(result.payload[key])">
                                <span class="section-kv-item__label">{{ formatLabel(subKey) }}</span>
                                <span class="section-kv-item__value">{{ formatInlineValue(result.payload[key][subKey]) }}</span>
                              </div>
                            </div>
                          </div>
                        </ng-container>
                        <ng-container *ngIf="isArray(result.payload[key])">
                          <div class="section-kv--nested">
                            <span class="section-kv-item__label">{{ formatLabel(key) }} ({{ result.payload[key].length }})</span>
                            <table class="section-table section-table--mini" *ngIf="getArrayColumns(result.payload[key]) as subCols">
                              <thead *ngIf="subCols.length">
                                <tr><th *ngFor="let col of subCols">{{ formatLabel(col) }}</th></tr>
                              </thead>
                              <tbody>
                                <tr *ngFor="let row of result.payload[key]">
                                  <td *ngFor="let col of subCols">{{ formatInlineValue(row[col]) }}</td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                        </ng-container>
                      </ng-container>
                    </div>
                  </ng-container>
                  <ng-template #deepPrimitiveBlock>
                    <div class="section-text-block">{{ formatValue(result.payload) }}</div>
                  </ng-template>
                </ng-template>
              </div>
            </div>
          </div>

          <div class="search-results-placeholder" *ngIf="!deepSearchResults.length">
            <mat-icon>search_off</mat-icon>
            <p>Keine Treffer für „{{ deepSearchTerm }}“.</p>
          </div>
        </ng-container>
      </div>
    </mat-tab>
  </mat-tab-group>
</div>
